"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactContenteditable = _interopRequireDefault(require("react-contenteditable"));

require("../styles/_asset-title.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ENTER_KEY = 13;

var getAssetTitle = function getAssetTitle(title, filename) {
  if (!title || !filename) {
    return {};
  }

  var filenameSplit = filename.split('.');
  var fileExtension = filenameSplit[filenameSplit.length - 1];
  var titleSplit = title.split(".".concat(fileExtension));
  return {
    fileExtension: fileExtension,
    title: titleSplit[0]
  };
};

var AssetTitle = /*#__PURE__*/function (_Component) {
  _inherits(AssetTitle, _Component);

  var _super = _createSuper(AssetTitle);

  function AssetTitle(props) {
    var _this;

    _classCallCheck(this, AssetTitle);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onChange", function (_ref) {
      var value = _ref.target.value;

      _this.setState({
        title: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSave", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, updateAsset, assetId, fetchAssets, assetTitle, title, _yield$updateAsset, data, error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, updateAsset = _this$props.updateAsset, assetId = _this$props.assetId, fetchAssets = _this$props.fetchAssets, assetTitle = _this$props.title;
              title = _this.state.title;

              if (_this._editableSpan && _this._editableSpan.current) {
                _this._editableSpan.current.scrollTo({
                  left: 0
                });
              }

              if (!(!title || title === assetTitle)) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return", void _this.setState({
                title: void 0
              }));

            case 5:
              _context.next = 7;
              return updateAsset({
                title: title
              });

            case 7:
              _yield$updateAsset = _context.sent;
              data = _yield$updateAsset.data;
              error = _yield$updateAsset.error;

              if (!(error || !data || !data.updateAsset)) {
                _context.next = 12;
                break;
              }

              return _context.abrupt("return", void _this.setState({
                title: void 0
              }));

            case 12:
              fetchAssets({
                assetId: assetId
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleEnterPressed", function (event) {
      var keyCode = event.keyCode;

      if (keyCode !== ENTER_KEY) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (!_this._editableSpan) {
        return;
      }

      _this._editableSpan.current.blur();
    });

    _this.state = {};
    _this._editableSpan = (0, _react.createRef)();
    return _this;
  }

  _createClass(AssetTitle, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          filename = _this$props2.filename,
          inverseColours = _this$props2.inverseColours,
          className = _this$props2.className,
          assetTitle = _this$props2.title;
      var newTitle = this.state.title;

      var _getAssetTitle = getAssetTitle(assetTitle, filename),
          fileExtension = _getAssetTitle.fileExtension,
          title = _getAssetTitle.title;

      return (/*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('asset-title', {
            'asset-title--inverse': inverseColours
          }, className)
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "asset-title__title"
        }, /*#__PURE__*/_react.default.createElement(_reactContenteditable.default, {
          innerRef: this._editableSpan,
          className: "foo",
          html: newTitle !== void 0 ? newTitle : title,
          onChange: this.onChange,
          tagName: "span",
          onBlur: this.onSave,
          onKeyDown: this.handleEnterPressed
        })), /*#__PURE__*/_react.default.createElement("span", {
          className: "asset-title__extension"
        }, ".".concat(fileExtension)))
      );
    }
  }]);

  return AssetTitle;
}(_react.Component);

var _default = AssetTitle;
exports.default = _default;